<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-toolbar">
                <h4 class="text-blue"><span @click="backParent" style="cursor: pointer;color: blue;">Term & Condition</span> /
                    <span v-if="term.id === null">New</span>
                    <span v-else>Edit</span>
                </h4>
                <div>
                    <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
                    <button type="button" @click="save" class="btn btn-sm btn-success pull-left" v-if="term.term_no == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                    <button type="button" @click="update" class="btn btn-sm btn-success pull-left" v-else><i class="fa fa-check" aria-hidden="true"></i> Save</button>
                </div>
                </div>
            </div>
        </div>
        <div class="card card-list">
            <div class="card-header"><h5><b>{{ term.term_no }}</b></h5></div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <label for="term_date" class="col-sm-3 col-form-label text-left">Name</label>
                            <div class="col-sm-9">
                                <input class="form-control" v-model="term.term_name"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="term_date" class="col-sm-3 col-form-label text-left">Date</label>
                            <div class="col-sm-9">
                                <datetime v-model="term.term_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                      <label for="term_date" class="col-sm-3 col-form-label text-left">Notes</label>
                      <wysiwyg v-model="term.notes" />
                    </div>
                </div>
            </div>
        </div>
        <pre>{{ term }}</pre>
    </div>
</template>

<script>
import axios from 'axios'
import { getHeader, salesUrl } from '../../config'

export default {
  name: 'SaleTermConditionForm',
  props: ['term'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    async update () {
      await axios.put(salesUrl + '/term-condition/' + this.term.id, this.term, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async save () {
      await axios.post(salesUrl + '/term-condition/', this.term, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.backParent()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
